export default __webpack_public_path__ + "static/media/install-app-3.6c482277.jpg";